<template>
  <div>
    <p>{{ $t("extraInformation") }}</p>
    <b-row class="ms-0 ms-0">
      <form-element
        v-for="formElement in fields"
        :key="formElement.name"
        v-model="form[formElement.name]"
        :form-element="formElement"
      />
    </b-row>
  </div>
</template>

<script>
import { BRow } from "bootstrap-vue"
import { getFields } from "@/services/checkout.js"
import FormElement from "@/components/form/FormElement"

export default {
  name: "CartDynamicFields",
  components: {
    BRow,
    FormElement,
  },
  data() {
    return {
      fields: [],
      form: {},
    }
  },
  watch: {
    form(form) {
      this.$emit("input", form)
    },
  },
  created() {
    this.getFormFields()
  },
  methods: {
    async getFormFields() {
      const result = await getFields()

      this.fields = result
    },
  },
}
</script>

<style scoped></style>
